<template>
  <div class="notification-dropdown">
    <button class="notification-btn" @click="toggleDropdown">
      <notification-badge :count="unreadCount" />
    </button>
    <div v-if="open" class="dropdown-list">
      <div v-if="notifications.length === 0" class="empty">Nenhuma notificação</div>
      <ul v-else>
        <li
          v-for="(notification, idx) in notifications"
          :key="notification.id || idx"
          :class="{ unread: !notification.read }"
        >
          <span>{{ notification.message }}</span>
          <small>{{ formatDate(notification.timestamp) }}</small>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useChatStore } from '../../stores/chatStore'
import { EventBus } from '../../services/eventBus.js'
import NotificationBadge from './NotificationBadge.vue'
import { DateManager } from '../../services/dateManager'
import { playNotificationSound } from '@/services/notificationSound'

const open = ref(false)
const notifications = ref<any[]>([])
const chatStore = useChatStore()
const unreadCount = computed(() => chatStore.unreadCount)

function toggleDropdown() {
  open.value = !open.value
}

function formatDate(date: string | number) {
  return DateManager.formatToBR(date)
}

function handleNotification(notification: any) {
  notifications.value.unshift(notification)
  // Play sound in a throttled, singleton-safe way
  playNotificationSound()
}

onMounted(() => {
  EventBus.on('notification', handleNotification)
})
onUnmounted(() => {
  EventBus.off('notification', handleNotification)
})
</script>

<style scoped>
.notification-dropdown {
  position: relative;
}
.notification-btn {
  background: none;
  border: none;
  cursor: pointer;
}
.dropdown-list {
  position: absolute;
  right: 0;
  top: 100%;
  background: #fff;
  border: 1px solid #eee;
  min-width: 250px;
  max-height: 350px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.unread {
  font-weight: bold;
}
.empty {
  padding: 1em;
  color: #888;
  text-align: center;
}
</style>
